/**
 * Sitewide "laatst bijgewerkt" — één plek om te bumpen bij content-/functionele wijzigingen.
 * Privacyverklaring heeft een eigen datum (PRIVACY_DECLARATION_LAST_UPDATED); die niet hier zetten.
 *
 * Bij wijziging: zet SITE_LAST_UPDATED op vandaag (YYYY-MM-DD). Sitemap lastmod sync't automatisch bij build.
 */
export const SITE_LAST_UPDATED = '2026-09-24';

/** Alleen bij echte wijziging privacy-/cookieverklaring. */
export const PRIVACY_DECLARATION_LAST_UPDATED = '2024-09-24';

export function getSiteLastUpdatedDateTimeISO(): string {
  return `${SITE_LAST_UPDATED}T12:00:00+02:00`;
}

export function formatSiteLastUpdatedNl(date = SITE_LAST_UPDATED): string {
  const [year, month, day] = date.split('-').map(Number);
  return new Intl.DateTimeFormat('nl-NL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'Europe/Amsterdam',
  }).format(new Date(year, month - 1, day));
}

export function formatPrivacyLastUpdatedNl(): string {
  return formatSiteLastUpdatedNl(PRIVACY_DECLARATION_LAST_UPDATED);
}
